define(function(require, exports, module) {
    'use strict';

    var PostMessageManager = require('managers/postMessage.manager');

    module.exports = new PostMessageManager();
});
